/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number to Words`)
};

const es_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número a Palabras`)
};

const de_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlen in Worte`)
};

const nl_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getal naar Woorden`)
};

const fr_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombres en Lettres`)
};

const it_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da numeri a parole`)
};

const pt_br2_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números em Palavras`)
};

const pt_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Números para Palavras`)
};

const ja_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字を単語に`)
};

const zh_nw_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字转文字`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nw_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nw_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nw_h1", locale)
	if (locale === "en") return en_nw_h1(inputs)
	if (locale === "es") return es_nw_h1(inputs)
	if (locale === "de") return de_nw_h1(inputs)
	if (locale === "nl") return nl_nw_h1(inputs)
	if (locale === "fr") return fr_nw_h1(inputs)
	if (locale === "it") return it_nw_h1(inputs)
	if (locale === "pt-BR") return pt_br2_nw_h1(inputs)
	if (locale === "pt") return pt_nw_h1(inputs)
	if (locale === "ja") return ja_nw_h1(inputs)
	return zh_nw_h1(inputs)
};